import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as u } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as y, useCallback as n } from "react";
import b from "../../../node_modules/lodash/startCase.js";
import $ from "../../../node_modules/lodash/replace.js";
import k from "../../molecules/Loader/Loader.js";
import o from "./Badge.module.scss.js";
import { Typography as B } from "../Typography/Typography.js";
import c from "../Icon/Icon.js";
import C from "../Tooltip/Tooltip.js";
const E = ({
  className: f = "",
  label: t,
  styles: i,
  size: m = "small",
  variant: r = "tinted",
  color: d = "gray",
  leadingIcon: p,
  trailingIcon: a,
  trailingIconTooltip: l,
  loading: e,
  testId: g,
  ...h
}) => {
  const x = {
    small: "xxs",
    medium: "sm"
  }, j = n(() => e ? /* @__PURE__ */ s.jsx(
    k,
    {
      ...r === "ghost" && {
        class1: "stroke-base-colors-grey-300",
        class2: "stroke-base-colors-grey-500"
      }
    }
  ) : null, [e, r]);
  return /* @__PURE__ */ s.jsxs(
    "span",
    {
      className: u(
        o.badge,
        o[`${r}${$(b(d), new RegExp(" ", "g"), "")}`],
        o[`${m}`],
        { "!hidden": !t && !p && !a && !e },
        f
      ),
      "data-testid": g,
      style: i,
      ...h,
      children: [
        j(),
        !e && p && r !== "ghost" && /* @__PURE__ */ s.jsx(
          c,
          {
            name: p,
            size: x[m]
          }
        ),
        r === "ghost" && /* @__PURE__ */ s.jsx("span", { className: o.ghostIndicator }),
        !!t && /* @__PURE__ */ s.jsx(
          B,
          {
            text: t,
            variant: "interface/medium/sm"
          }
        ),
        !e && a && r !== "ghost" && /* @__PURE__ */ s.jsx(
          C,
          {
            ...l,
            behavior: "tooltip",
            trigger: /* @__PURE__ */ s.jsx(
              c,
              {
                name: a,
                size: x[m]
              }
            )
          }
        )
      ]
    }
  );
}, F = y(E);
export {
  F as default
};
//# sourceMappingURL=Badge.js.map
